import { Page } from '@/core/architecture'

import { ResaleCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleCreate Page
 * Implemented as a practical sample.
 */
export const ResaleCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ResaleCreateTemplate state={state} {...actions} />
}
